<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card card-stats">

                    <div class="card-header card-header-{{color}}-6">
                        <h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Non-Turning Inventory</h4>
                        <p class="card-category text-right"></p>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="filterForm" (ngSubmit)="runReport()">
                            <div class="row">
                                <div class="col-md-3">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>From Date</mat-label>
                                        <input matInput [matDatepicker]="fromPicker" formControlName="fromdate">
                                        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #fromPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>To Date</mat-label>
                                        <input matInput [matDatepicker]="toPicker" formControlName="todate">
                                        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #toPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Days Without Sales</mat-label>
                                        <input matInput type="number" min="0" formControlName="days_without_sales">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Min Stock Quantity</mat-label>
                                        <input matInput type="number" min="0" formControlName="min_stock_quantity">
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Locations</mat-label>
                                        <mat-select formControlName="locations" multiple>
                                            <mat-option *ngFor="let b of branches" [value]="b.loccode">{{ b.loccode }} - {{ b.locationname }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Categories</mat-label>
                                        <mat-select formControlName="categories" multiple>
                                            <mat-option *ngFor="let c of categories" [value]="c.categoryid">{{ c.categorydescription || c.categoryid }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Brands</mat-label>
                                        <mat-select formControlName="brands" multiple>
                                            <mat-option *ngFor="let m of brands" [value]="m.manufacturer_id">{{ m.name || m.brand || m.manufacturer }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-4 d-flex align-items-center">
                                    <mat-checkbox formControlName="include_zero_stock">Include Zero Stock</mat-checkbox>
                                </div>
                                <div class="col-md-8 text-right">
                                    <button mat-raised-button color="primary" type="submit" [disabled]="loading">Run</button>
                                </div>
                            </div>
                        </form>
                    </div>
                        
                        <div class="card-body">
                            <div class="row">
                                
                                <mat-progress-spinner class="ml-auto mr-auto" *ngIf="loading" mode="indeterminate" diameter="32"></mat-progress-spinner>
                                <div class="col-md-12">
                                    <p class="mt-2 mb-2">Total Qty: {{ totals.total_quantity | number }} | Total Value: {{ totals.total_value | currency:'USD':'symbol' }}</p>
                                </div>

                                <div class="col-md-12">
                                    <div class="row mb-2">
                                        <div class="col-md-3 ml-0 mr-auto">
                                            <mat-form-field appearance="outline" class="cover-days-field">
                                                <mat-label>Cover Days ≥</mat-label>
                                                <input matInput type="number" [value]="slowCoverDays" (input)="onCoverDaysChange($event.target.value)">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-9 text-right ml-auto">
                                            <button class="btn btn-success btn-sm mr-2" (click)="$event.preventDefault();exportXls()" [disabled]="sending || !rowsData.length">
                                                <i class="fa fa-file-excel-o"></i> XLS
                                            </button>
                                            <button class="btn btn-danger btn-sm" (click)="$event.preventDefault();exportPdf()" [disabled]="sending || !rowsData.length">
                                                <i class="fa fa-file-pdf-o"></i> PDF
                                            </button>
                                        </div>
                                    </div>
                                    <div #print_table>
                                        <div class="table table-responsive" *ngIf="!loading">
                                            <table class="table table-striped table-bordered table-hover table-fixed">
                                            <thead>
                                                <tr>
                                                    <th *ngFor="let column of displayedColumns" class="text-uppercase" [ngClass]="{'text-right': isNumeric(column)}">{{ prettyHeader(column) }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                    <tr *ngFor="let r of filteredRows; trackBy: trackRow">
                                                        <td *ngFor="let column of displayedColumns" [ngClass]="{'text-right': isNumeric(column)}">{{ formatCell(r, column) }}</td>
                                                    </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>

                       
                        </div>
                </div>
            </div>
        </div>
    </div>
</div>


